// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentsActions-module__container--1zTxr","exitButton":"DocumentsActions-module__exitButton--38oqQ"};